<template>
  <section id="gold-article" class="section-trending-gold">
    <div class="header">
      <span class="header-title">บทความเกี่ยวกับทอง</span>
    </div>
    <div id="article-container" :class="getClassFade()">
      <swiper
        v-if="articles.length"
        :options="swiperOption"
        class="article-list"
        @slideChange="getIndex"
        ref="mySwiper"
      >
        <swiper-slide
          class="post-card"
          v-for="(article, index) in articles.slice(0,page)"
          :key="index"
        >
          <div
            class="post-card-link"
            @click="open(article.link+'?webview=line')"
            data-action="open_post"
            :data-postid="article.id"
            data-listname="market_gold"
          >
            <img
              class="thumbnail"
              :src="article.post_thumbnail_url"
              content="width=device-width, initial-scale=1.0"
            />
            <div class="description">
              <p class="block-ellipsis" v-html="article.title ? article.title.rendered : ''"></p>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        lazy: true,
        slidesOffsetBefore: 0,
        spaceBetween: 10,
        autoHeight: true,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange() {}
          //   tap() {}
        }
      },
      articles: [],
      page: 10,
      slideIndex: 0,
      isFirstSlide: true,
      isLastSlide: false,
      goldArticleTag: 103
    };
  },
  mounted() {
    this.getArticle();
  },
  methods: {
    ...mapActions("article", ["findTagsByTagName", "findArticleByParams"]),
    async getArticle() {
      try {
        let obj = {
          tags: this.goldArticleTag,
          per_page: this.page
        };
        const rs_article = await this.findArticleByParams(obj);
        if (rs_article && rs_article.length > 0) {
          this.articles = rs_article;
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    open(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    async infiniteHandler($state) {
      if (this.page <= 100) {
        this.page += 10;
        this.getArticle();
        setTimeout(() => {
          $state.loaded();
        }, 1000);
      } else {
        $state.complete();
      }
    },
    getIndex() {
      this.isFirstSlide = this.$refs.mySwiper.swiper.isBeginning;
      this.isLastSlide = this.$refs.mySwiper.swiper.isEnd;
    },
    getClassFade() {
      if (this.isFirstSlide) {
        return "fade-right";
      } else if (this.isLastSlide) {
        return "fade-left";
      } else {
        return "fade-right fade-left";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$radius-size: 8px;
.article-list {
  padding: 0 2px;
}
.swiper-pagination {
  bottom: -6px;
  position: relative;
}

#gold-article {
  .header {
    i {
      color: $color-normal-text;
    }
    .header-title {
      display: inline-block;
      margin-top: 28px;
      // margin-left: 8px;
      margin-bottom: 8px;
      @extend %font-size-m;
      font-weight: bold;
      color: $color-normal-text;
    }
  }

  .post-card {
    background-color: $color-white;
    border-radius: $radius-size;
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    .post-card-link {
      text-decoration: none;
      div {
        pointer-events: none;
      }
      img {
        pointer-events: none;
      }
    }
    .thumbnail {
      border-top-left-radius: $radius-size;
      border-top-right-radius: $radius-size;
      display: block;
      width: 100%;
      height: 170px;
      object-fit: cover;
    }
    .description {
      @extend %font-size-ss;
      font-weight: bold;
      color: $color-normal-text;
      padding: 16px;
      margin: 0px;
      display: flex;
      .block-ellipsis {
        display: inline-block;
        display: -webkit-box;
        margin: 0; // 0 auto
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 42px;
        -webkit-line-clamp: 2;
      }
      .readmore {
        text-decoration: underline;
        color: $color-primary;
        margin-left: 2px;
        min-width: 3.9em;
        display: inline-block;
      }
    }
  }
}

.section-trending-gold {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  @include responsive(desktop) {
    max-width: $container-width-desktop;
  }
  overflow-x: hidden;

  .trending-list {
    width: 110%;
    padding: 10px 0 10px 3px;
    .item {
      width: 100%;
      max-width: 104px;
      border-radius: 4px;
      box-shadow: 0 0 6px 0 rgba(217, 217, 217, 0.5);
      background-color: $color-white;
      height: 128px;
      margin-right: 10px;
      .trending-data {
        position: relative;
        padding: 8px;
        line-height: 1;
        height: 100%;
        margin-right: auto;
        margin-left: auto;
        h4 {
          margin: 0;
          @extend %font-size-m;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #444444;
          white-space: nowrap;
          width: 85px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        time {
          @extend %font-size-ss;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #d1d1d1;
        }
        .percent {
          margin-top: 30px;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #da1616;
        }
        .plus {
          color: $color-plus;
        }
        .minus {
          color: $color-minus;
        }
        .price {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #444444;
        }
        .order-trending {
          position: absolute;
          bottom: 0;
          right: 0;
          font-size: 60px;
          font-weight: bold;
          color: #f9f9f9;
          vertical-align: baseline;
          line-height: 0.71;
        }
      }
    }
  }
  .fade-right {
    &:after {
      content: "";
      width: 25px;
      height: 85%;
      z-index: 1;
      position: absolute;
      right: 0;
      bottom: 0;
      pointer-events: none;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
      background: -moz-linear-gradient(
        left,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.404) 100%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.404) 100%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.404) 100%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
    }
  }
  .fade-left {
    &:before {
      content: "";
      width: 25px;
      height: 85%;
      z-index: 2;
      position: absolute;
      left: -3px;
      bottom: 0;
      pointer-events: none;
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&1+0,0+100;White+to+Transparent */
      background: -moz-linear-gradient(
        left,
        rgba(255, 255, 255, 0.404) 0%,
        rgba(255, 255, 255, 0) 100%
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        rgba(255, 255, 255, 0.404) 0%,
        rgba(255, 255, 255, 0) 100%
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.404) 0%,
        rgba(255, 255, 255, 0) 100%
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
    }
  }
  .text-notfound {
    @extend %font-size-ss;
    text-align: center;
    color: $color-normal-text;
  }
}
</style>